import TableRow from "@mui/material/TableRow";
import { Box, Chip } from "@mui/material";
import { useState } from "react";
import { ChevronRight } from "@mui/icons-material";
import type { SetURLSearchParams } from "react-router-dom";
import { dateFormat, formatMoney } from "../../../common/utils";
import { Span } from "../components/Typography";
import DefaultImage from "../images/default-merchant-image.png";
import { LiParagraph, LiTableCell } from "../components/pieces";
import type { Purchase } from "../../../types";

const chipMap: Record<string, "info" | "error" | "success"> = {
    Pending: `info`,
    Ineligible: `error`,
    Earned: `success`,
};

interface ShoppingTableRowProps {
    purchase: Purchase;
    setSearchParams: SetURLSearchParams;
}

const ShoppingTableRow = (props: ShoppingTableRowProps) => {
    const { purchase, setSearchParams } = props;
    const [errorImg, setErrorImg] = useState<string | undefined>();

    return (
        <TableRow sx={{ border: `none`, borderTop: `1px solid #E1E1E1` }}>
            <LiTableCell sx={{ textAlign: `left`, padding: `24px`, width: 105 }}>
                <LiParagraph>{Date.parse(purchase.date) ? dateFormat(new Date(purchase.date)) : ``}</LiParagraph>
            </LiTableCell>
            <LiTableCell sx={{ padding: `24px 0 24px 24px`, width: `30px` }}>
                <Box
                    onError={() => {
                        setErrorImg(DefaultImage);
                    }}
                    mr="15px"
                    sx={{
                        maxHeight: 30,
                        height: `auto`,
                        maxWidth: 30,
                        width: `auto`,
                    }}
                    component="img"
                    src={errorImg || `https://s3.amazonaws.com/retailerimages/icon/${purchase.storeGuid}`}
                />
            </LiTableCell>
            <LiTableCell sx={{ padding: `24px 24px 24px 0` }}>
                <LiParagraph fontWeight={700}>{purchase.store}</LiParagraph>
            </LiTableCell>
            <LiTableCell sx={{ textAlign: `right`, padding: `24px 28px 24px 24px`, width: 120 }}>
                <LiParagraph>{formatMoney(purchase.cashback)}</LiParagraph>
            </LiTableCell>
            <LiTableCell sx={{ textAlign: `center`, padding: `24px 28px 24px 24px`, width: 80 }}>
                <Box
                    sx={{
                        display: `flex`,
                        alignItems: `center`,
                        justifyContent: `center`,
                    }}
                >
                    <Chip
                        sx={{ padding: `1px 8px 0` }}
                        size="small"
                        label={purchase.status}
                        color={chipMap[purchase.status]}
                    />
                </Box>
            </LiTableCell>
            <LiTableCell sx={{ textAlign: `left`, padding: `24px`, width: 70 }}>
                <Box
                    sx={{ cursor: `pointer`, whiteSpace: `nowrap` }}
                    onClick={() => {
                        setSearchParams({ showDetails: encodeURIComponent(purchase.invoiceId) });
                    }}
                >
                    <Span sx={{ verticalAlign: `middle` }}>
                        {purchase.status === `Ineligible` ? `Terms` : `Details`}
                        <ChevronRight sx={{ verticalAlign: `middle` }} />
                    </Span>
                </Box>
            </LiTableCell>
        </TableRow>
    );
};

export default ShoppingTableRow;
